import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowDown, FiCheckCircle } = FiIcons;

function Hero() {
  const scrollToPrograms = () => {
    document.getElementById('programs')?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  return (
    <header className="hero">
      <div className="hero-overlay" />
      <div className="hero-content">
        <p className="eyebrow">Dallas PTA Program Directory</p>
        <h1>Compare PTA Programs in Dallas</h1>
        <p className="hero-copy">
          Explore physical therapist assistant programs across the Dallas-Fort Worth
          region, including public colleges, career schools, clinical education,
          credentials, and important questions to ask before applying.
        </p>
        <button className="primary-button" onClick={scrollToPrograms}>
          Explore Dallas PTA Programs
          <SafeIcon icon={FiArrowDown} aria-hidden="true" />
        </button>
        <p className="trust-line">
          <SafeIcon icon={FiCheckCircle} aria-hidden="true" />
          Independent comparisons of PTA education, clinical preparation, costs, and
          locations
        </p>
      </div>
    </header>
  );
}

export default Hero;